export default __webpack_public_path__ + "static/media/flash.68c802d6.svg";